'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
exports.parseWasm = void 0;
var wasm_parser_1 = require('@webassemblyjs/wasm-parser');
function base64StringToUint8Array(str) {
  if (typeof Buffer !== 'undefined') {
    // Node
    return Buffer.from(str, 'base64');
  } else {
    // Browser
    return new Uint8Array(
      atob(str.toString().trim())
        .split('')
        .map(function (c) {
          return c.charCodeAt(0);
        }),
    );
  }
}
function parseWasm(wasmb64) {
  return (0, wasm_parser_1.decode)(base64StringToUint8Array(wasmb64));
}
exports.parseWasm = parseWasm;
//# sourceMappingURL=parseWasm.js.map
